import { render } from "./StripeSessionDispute.vue?vue&type=template&id=77a21c55"
import script from "./StripeSessionDispute.vue?vue&type=script&lang=js"
export * from "./StripeSessionDispute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__